import { render, staticRenderFns } from "./VFile.vue?vue&type=template&id=512964c1&scoped=true"
import script from "./VFile.vue?vue&type=script&lang=js"
export * from "./VFile.vue?vue&type=script&lang=js"
import style0 from "./VFile.vue?vue&type=style&index=0&id=512964c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512964c1",
  null
  
)

export default component.exports